import { useState, useEffect } from "react";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import { useAuth } from "./useAuth";

/**
 * Load client document from organizations/{organizationId}/clients/{clientId}
 * for display (name, avatar, etc.). Only runs when clientId and organizationId are set.
 */
export function useClientProfile() {
  const { clientId, organizationId } = useAuth();
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!clientId || !organizationId) {
      setClient(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    const ref = firebase
      .firestore()
      .collection("organizations")
      .doc(organizationId)
      .collection("clients")
      .doc(clientId);
    const unsubscribe = ref.onSnapshot(
      (snapshot) => {
        if (snapshot.exists) {
          setClient({ id: snapshot.id, ...snapshot.data() });
        } else {
          setClient(null);
        }
        setLoading(false);
      },
      (err) => {
        setError(err);
        setClient(null);
        setLoading(false);
      }
    );
    return () => unsubscribe();
  }, [clientId, organizationId]);

  return { client, loading, error };
}
